export default "<span>\r\n  You are successfully logged in!!! 🍕\r\n</span>\r\n";